export default "__VITE_ASSET__Cx$SYbah__"